<template>
  <div class="wrapper page-contact-content">
    <div v-if="loading" class="loading-container">
      <div id="loading"></div>
    </div>
    <div class="contact-wrapper">
      <div class="wrapper split-content d-flex justify-content-center">
        <div class="w-100">
          <div class="d-flex min-vh-100">
            <div class="w-100 d-flex align-items-center bg-orange-primary justify-content-center flex-column">
              <div id="zf_div_Ec_dPLw6VQKHsRw4nnS23zCg6C0zgEeEreIXTVegwO8"></div>
              <p style="color: white" v-if="!loading">
                <a :href="`/${$route.params.lang || ''}`">
                  {{ resource["contactPage.HomeLink"] }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',

  components: {},

  data() {
    return {
      loading: true,
    };
  },

  mounted() {
    const f = document.createElement('iframe');
    f.src = 'https://forms.zohopublic.eu/techcareer122/form/ContactUsOrange/formperma/Ec_dPLw6VQKHsRw4nnS23zCg6C0zgEeEreIXTVegwO8?zf_rszfm=1';
    f.style.border = 'none';
    f.style.height = '730px';
    f.style.width = '400px';
    f.style.transition = 'all 0.5s ease';

    const d = document.getElementById('zf_div_Ec_dPLw6VQKHsRw4nnS23zCg6C0zgEeEreIXTVegwO8');
    d.appendChild(f);
    window.addEventListener(
      'message',
      () => {
        const evntData = event.data;
        if (evntData && evntData.constructor === String) {
          const IframeData = evntData.split('|');
          if (IframeData.length === 2) {
            const ZfPerma = IframeData[0];
            const ZfIfrmHtNw = `${parseInt(IframeData[1], 10) + 15}px`;
            const iframe = document
              .getElementById('zf_div_Ec_dPLw6VQKHsRw4nnS23zCg6C0zgEeEreIXTVegwO8')
              .getElementsByTagName('iframe')[0];
            if (iframe.src.indexOf('formperma') > 0 && iframe.src.indexOf(ZfPerma) > 0) {
              const prevIframeHeight = iframe.style.height;
              this.loading = false;
              if (prevIframeHeight !== ZfIfrmHtNw) {
                iframe.style.height = ZfIfrmHtNw;
              }
            }
          }
        }
      },
      false,
    );
  },
};
</script>

<style lang="scss">
@import "~@/style/starter.scss";

.contact-wrapper {
  background: #fff;
  height: 100%;
}

.home-link {
  text-decoration: underline;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  border: 0;
  top: 0;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  z-index: 4444;
}

#loading {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #e6e6e6;
  border-radius: 50%;
  border-top-color: #ff8d06;
  animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
  -webkit-animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>
